import { useState } from "react";
import { Box, Typography, Autocomplete, TextField } from "@mui/material";

const SelectLine = ({
                        label,
                        name,
                        value,
                        onChange,
                        onBlur,
                        required = false,
                        options = [],
                        error,
                        helperText,
                    }) => {
    const [open, setOpen] = useState(false);

    return (
        <Box sx={{ mb: 3, minWidth: 300 }}>
            <Typography
                sx={{
                    fontSize: 16,
                    color: error ? "#d32f2f" : "#004B88",
                    mb: 1,
                    fontWeight: 400,
                }}
            >
                {label}
                {required && (
                    <span style={{ color: error ? "#d32f2f" : "#004B88" }}>*</span>
                )}
            </Typography>
            <Autocomplete
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                //disableClearable
                value={options.find((opt) => opt.value === value) || null}
                options={options}
                getOptionLabel={(opt) => opt.label || ""}
                onChange={(e, newVal) =>
                    onChange({
                        target: { name, value: newVal?.value ?? "" },
                    })
                }
                onBlur={() =>
                    onBlur({
                        target: { name, value }
                    })
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        error={Boolean(error)}
                        helperText={error ? helperText : ""}
                        InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                        }}
                        sx={{
                            "& .MuiInputBase-root": {
                                color: error ? "#d32f2f" : "#004B88",
                                borderBottom: `1px solid ${
                                    error ? "#d32f2f" : "#004B88"
                                }`,
                                pb: 0.5,

                                "&:hover": {
                                    borderBottom: `1px solid ${
                                        error ? "#d32f2f" : "#004B88"
                                    }`,
                                },
                            },

                            "& .MuiFormHelperText-root": {
                                color: "#d32f2f",
                                mt: "4px",
                            },

                            "& .MuiSvgIcon-root": {
                                color: error ? "#d32f2f" : "#004B88",
                            },
                        }}
                    />
                )}
            />

            {error && !helperText?.length && (
                <Typography sx={{ color: "#d32f2f", fontSize: 13, mt: "2px" }}>
                    {helperText}
                </Typography>
            )}
        </Box>
    );
};

export default SelectLine;
